export const availableOptions = [
  {
    title: "Teams",
    link: "/app/settings/teams",
    iconKey: "users",
    forLead: true,
  },
  {
    title: "Feeling causes",
    link: "/app/causessettings",
    state: { type: "personal" },
    iconKey: "lightbulb",
  },
  {
    title: "Subscription",
    link: "/app/premium",
    iconKey: "users",
    forLead: true,
  },
  {
    title: "Manage subscription-details",
    forDevEnv: false,
    link: "/app/managesubscription",
    iconKey: "list",
  },
  {
    title: "Leave team",
    function: "setShowLeaveTeamModal",
    teamMember: true,
    iconKey: "logIn",
    state: { type: "team" },
    forLead: false,
  },
];



export const accountOptions = [
  {
    title: "Account",
    link: "/app/account",
    iconKey: "account",
    state: { type: "team" },
  },
  {
    title: "Notifications",
    link: "/app/notifications",
    iconKey: "bell",
    state: { type: "team" },
  },
  /*
  {
    title: "Theme",
    link: "/app/theme",
    iconKey: "palette",
    state: { type: "account" },
  },
   */
];
